import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/a5c6u8x8_mmt%20logo.jpg" 
                alt="MMT Logo" 
                className="h-14 w-14 object-contain"
              />
              <div>
                <h1 className="text-xl font-bold text-green-700">MMT</h1>
                <p className="text-xs text-gray-600">Prabuddha Bharath</p>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-6">
              <button onClick={() => scrollToSection('home')} className="nav-link">Home</button>
              <button onClick={() => scrollToSection('about')} className="nav-link">Our Story</button>
              <button onClick={() => scrollToSection('vision')} className="nav-link">Vision & Mission</button>
              <button onClick={() => scrollToSection('team')} className="nav-link">Team</button>
              <button onClick={() => scrollToSection('dhamma')} className="nav-link">Dhamma</button>
              <button onClick={() => scrollToSection('initiatives')} className="nav-link">Initiatives</button>
              <button onClick={() => scrollToSection('donate')} className="nav-link">Donate</button>
              <button onClick={() => scrollToSection('volunteer')} className="nav-link">Volunteer</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <button onClick={() => scrollToSection('home')} className="mobile-nav-link">Home</button>
            <button onClick={() => scrollToSection('about')} className="mobile-nav-link">Our Story</button>
            <button onClick={() => scrollToSection('vision')} className="mobile-nav-link">Vision & Mission</button>
            <button onClick={() => scrollToSection('team')} className="mobile-nav-link">Team</button>
            <button onClick={() => scrollToSection('dhamma')} className="mobile-nav-link">Dhamma</button>
            <button onClick={() => scrollToSection('initiatives')} className="mobile-nav-link">Initiatives</button>
            <button onClick={() => scrollToSection('donate')} className="mobile-nav-link">Donate</button>
            <button onClick={() => scrollToSection('volunteer')} className="mobile-nav-link">Volunteer</button>
            <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
